<template>
  <aside class="sidebar" :class="[{ collapsed: isSidebarClosed }, shopInfo.plan + '-plan']" v-if="windowWidth >= 768 && mode == 'shop'">
    <a :href="url" class="logo justify-content-center justify-content-lg-start align-items-center mt-1">
      <i class="icon icon-arrow-left"></i>
      <span class="logo__text typo-paragraph12">{{ $t("sidebar.backShopify") }}</span>
    </a>

    <section class="sidenav mt-1">
      <PerfectScrollbar class="scrollBody" :options="scrollOptions">
        <router-link :to="{ name: 'Dashboard' }" class="nav-link dashboard flex-shrink-0" :class="{ 'popover--disabled': isActive.dashBoard }" v-popover:tooltip.right="this.$t('sidebar.dashboardTooltip')">
          <i class="icon icon-new-dashboard"></i>
          <span class="text-item">{{ $t("sidebar.dashboard") }}</span>
        </router-link>
        <article class="pages d-none d-lg-flex flex-column">
          <div class="nav-link subtitle">
            <span>{{ $t("upperCase.pages") }}</span>
          </div>

          <router-link :to="goTo('LandingPages')" class="nav-link" v-if="permission.subpages" :class="{ 'popover--disabled': isActive.subPages }" v-popover:tooltip.right="$t('page.subpagesTooltip')">
            <i class="icon icon-new-landing-page"></i>
            <span class="text-item">{{ $tc("page.newLandingPages", 2) }}</span>
            <a v-popover:tooltip.right="$t('dashboard.createNewPageTxt')" class="btn nav-link__quick-add" @click.stop @click.prevent="onCreateNewPage('subpages', DASHBOARD_SIDEBAR_EVENT.CREATE_NEW_LANDING_PAGE_SHORTCUT_CLICKED)">
              <i class="icon icon-new-plus-small text-light1-small text-light1 m-0"></i>
            </a>
          </router-link>
          <a class="nav-link disabled" v-popover:tooltip.right="$t('page.pleaseUpgrade')" v-else>
            <i class="icon icon-new-landing-page"></i>
            <span class="text-item">{{ $tc("page.newLandingPages", 2) }}</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-auto mr-xl-3 mr-lg-1 mr-mlg-2">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 7C3.22386 7 3 7.22386 3 7.5V14.5C3 14.7761 3.22386 15 3.5 15H12.5C12.7761 15 13 14.7761 13 14.5V7.5C13 7.22386 12.7761 7 12.5 7H3.5ZM2 7.5C2 6.67158 2.67158 6 3.5 6H12.5C13.3284 6 14 6.67158 14 7.5V14.5C14 15.3284 13.3284 16 12.5 16H3.5C2.67158 16 2 15.3284 2 14.5V7.5Z" fill="#A6A6A6" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1C6.34314 1 5 2.34315 5 4V6.5C5 6.77614 4.77614 7 4.5 7C4.22386 7 4 6.77614 4 6.5V4C4 1.79086 5.79086 0 8 0C10.2091 -3.57628e-07 12 1.79086 12 4V6.5C12 6.77614 11.7761 7 11.5 7C11.2239 7 11 6.77614 11 6.5V4C11 2.34314 9.65685 1 8 1Z" fill="#A6A6A6" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.70711 10.2929C8.31658 9.90237 7.68342 9.90237 7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071C9.09763 11.3166 9.09763 10.6834 8.70711 10.2929ZM9.41421 9.58579C8.63316 8.80474 7.36684 8.80474 6.58579 9.58579C5.80474 10.3668 5.80474 11.6332 6.58579 12.4142C7.36684 13.1953 8.63316 13.1953 9.41421 12.4142C10.1953 11.6332 10.1953 10.3668 9.41421 9.58579Z" fill="#A6A6A6" />
            </svg>
          </a>

          <router-link :to="goTo('HomePages')" class="nav-link" v-if="permission.homepages" :class="{ 'popover--disabled': isActive.homePages }" v-popover:tooltip.right="$t('page.homepagesTooltip')">
            <i class="icon icon-new-homepage"></i>

            <span class="text-item">{{ $tc("page.homepages", 2) }}</span>
            <a v-popover:tooltip.right="$t('dashboard.createNewPageTxt')" class="btn nav-link__quick-add" @click.stop @click.prevent="onCreateNewPage('homepages', DASHBOARD_SIDEBAR_EVENT.CREATE_NEW_HOME_PAGE_SHORTCUT_CLICKED)">
              <i class="icon icon-new-plus-small text-light1 m-0"></i>
            </a>
          </router-link>
          <a class="nav-link disabled" v-popover:tooltip.right="$t('page.pleaseUpgrade')" v-else>
            <i class="icon icon-new-homepage"></i>
            <span class="text-item">{{ $tc("page.homepages", 2) }}</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-auto mr-xl-3 mr-lg-1 mr-mlg-2">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 7C3.22386 7 3 7.22386 3 7.5V14.5C3 14.7761 3.22386 15 3.5 15H12.5C12.7761 15 13 14.7761 13 14.5V7.5C13 7.22386 12.7761 7 12.5 7H3.5ZM2 7.5C2 6.67158 2.67158 6 3.5 6H12.5C13.3284 6 14 6.67158 14 7.5V14.5C14 15.3284 13.3284 16 12.5 16H3.5C2.67158 16 2 15.3284 2 14.5V7.5Z" fill="#A6A6A6" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1C6.34314 1 5 2.34315 5 4V6.5C5 6.77614 4.77614 7 4.5 7C4.22386 7 4 6.77614 4 6.5V4C4 1.79086 5.79086 0 8 0C10.2091 -3.57628e-07 12 1.79086 12 4V6.5C12 6.77614 11.7761 7 11.5 7C11.2239 7 11 6.77614 11 6.5V4C11 2.34314 9.65685 1 8 1Z" fill="#A6A6A6" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.70711 10.2929C8.31658 9.90237 7.68342 9.90237 7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071C9.09763 11.3166 9.09763 10.6834 8.70711 10.2929ZM9.41421 9.58579C8.63316 8.80474 7.36684 8.80474 6.58579 9.58579C5.80474 10.3668 5.80474 11.6332 6.58579 12.4142C7.36684 13.1953 8.63316 13.1953 9.41421 12.4142C10.1953 11.6332 10.1953 10.3668 9.41421 9.58579Z" fill="#A6A6A6" />
            </svg>
          </a>

          <template v-if="permission.productpages">
            <router-link :to="goTo('ProductPages')" class="nav-link open" :class="{ 'popover--disabled': isActive.productPages }" v-popover:tooltip.right="$t('page.productpagesTooltip')">
              <i class="icon icon-new-product-page"></i>

              <span class="text-item">{{ $tc("page.productpages", 2) }}</span>
              <a v-popover:tooltip.right="$t('dashboard.createNewPageTxt')" class="btn nav-link__quick-add" @click.stop @click.prevent="onCreateNewPage('productpages', DASHBOARD_SIDEBAR_EVENT.CREATE_NEW_PRODUCT_PAGE_SHORTCUT_CLICKED)">
                <i class="icon icon-new-plus-small text-light1 m-0"></i>
              </a>
            </router-link>
          </template>
          <router-link
            class="nav-link open"
            :class="{ 'popover--disabled': isActive.productPages }"
            v-popover:tooltip.right="$t('page.productpagesTooltip')"
            :to="{
              name: 'PricingOnboarding',
              params: {
                id: patIdsPricingOnboard.product
              }
            }"
            v-else
          >
            <i class="icon icon-new-product-page"></i>
            <span class="text-item">{{ $tc("page.productpages", 2) }}</span>
            <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("dataNewPlan.plan.build") }}</span>
          </router-link>
          <template v-if="permission.collectionpages">
            <router-link :to="goTo('CollectionPages')" class="nav-link open" :class="{ 'popover--disabled': isActive.collectionPages }" v-popover:tooltip.right="$t('page.collectionpagesTooltip')">
              <i class="icon icon-new-collection-page"></i>
              <span class="text-item">{{ $tc("page.collectionpages", 2) }}</span>
              <a v-popover:tooltip.right="$t('dashboard.createNewPageTxt')" class="btn nav-link__quick-add" @click.stop @click.prevent="onCreateNewPage('collectionpages', DASHBOARD_SIDEBAR_EVENT.CREATE_NEW_COLLECTION_PAGE_SHORTCUT_CLICKED)">
                <i class="icon icon-new-plus-small text-light1 m-0"></i>
              </a>
            </router-link>
          </template>
          <router-link
            class="nav-link open "
            v-popover:tooltip.right="$t('page.pleaseUpgrade')"
            :to="{
              name: 'PricingOnboarding',
              params: {
                id: patIdsPricingOnboard.collection
              }
            }"
            v-else
          >
            <i class="icon icon-new-collection-page"></i>
            <span class="text-item">{{ $tc("page.collectionpages", 2) }}</span>
            <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("dataNewPlan.plan.build") }}</span>
          </router-link>
          <router-link :to="goTo('ArticlePages')" class="nav-link" v-if="permission.articlepages" :class="{ 'popover--disabled': isActive.articlePages }" v-popover:tooltip.right="$t('sidebar.blogArtTooltip')">
            <i class="icon icon-new-blog"></i>
            <span class="text-item">{{ $t("page.blog") }}</span>
            <a v-popover:tooltip.right="$t('dashboard.createNewPageTxt')" class="btn nav-link__quick-add" @click.stop @click.prevent="onCreateNewPage('articlepages', DASHBOARD_SIDEBAR_EVENT.CREATE_NEW_BLOG_POST_SHORTCUT_CLICKED)">
              <i class="icon icon-new-plus-small text-light1 m-0"></i>
            </a>
          </router-link>
          <router-link
            class="nav-link "
            v-popover:tooltip.right="$t('page.pleaseUpgrade')"
            :to="{
              name: 'PricingOnboarding',
              params: {
                id: patIdsPricingOnboard.blog
              }
            }"
            v-else
          >
            <i class="icon icon-new-blog"></i>
            <span class="text-item">{{ $t("page.blog") }}</span>
            <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("dataNewPlan.plan.build") }}</span>
          </router-link>
        </article>
        <article class="pages d-none d-lg-flex flex-column" v-if="showInstant">
          <div class="nav-link subtitle">
            <span>{{ $t("upperCase.instantPages") }}</span>
          </div>

          <router-link :to="{ path: '/instant/static' }" class="nav-link" :class="{ 'popover--disabled': isActive.instant }" v-popover:tooltip.right="$t('page.instantpagesTooltip')">
            <i class="icon icon-new-landing-page"></i>
            <span class="text-item">{{ $t("page.instantpages") }}</span>
            <span class="badge badge-instant" style="transform: translateY(1px);">{{ $t("capitalize.beta") }}</span>
          </router-link>
          <!-- <a class="nav-link disabled" v-popover:tooltip.right="$t('page.pleaseUpgrade')" v-else>
            <i class="icon icon-new-landing-page"></i>
            <span class="text-item">{{ $t("page.instantpages") }}</span>
            <span class="badge badge-warn" style="transform: translateY(1px);">{{ $t("capitalize.beta") }}</span>
            <i class="icon icon-new-lock ml-auto mr-xl-3 mr-lg-1 mr-mlg-2"></i>
          </a> -->
        </article>
        <article class="pages d-none d-lg-flex flex-column">
          <div class="nav-link subtitle">
            <span>{{ $t("upperCase.analytics") }}</span>
          </div>
          <template v-if="isGemPagesV7">
            <div class="nav-link disabled">
              <i class="icon icon-new-analytics"></i>
              <span class="text-item">{{ $t("analytic.ab.title") }}</span>
              <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("dataNewPlan.plan.upcoming") }}</span>
            </div>
          </template>
          <template v-else>
            <router-link :to="{ name: 'ABTesting' }" class="nav-link" :class="{ 'popover--disabled': isActive.ab }" v-popover:tooltip.right="$t('analytic.ab.description')" v-if="permission.analytics" :key="$t('analytic.ab.description')">
              <i class="icon icon-new-analytics"></i>
              <span class="text-item">{{ $t("analytic.ab.title") }}</span>
              <!-- <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("capitalize.pro") }}</span> -->
            </router-link>
            <router-link
              v-else
              :to="{
                name: 'PricingOnboarding',
                params: {
                  id: patIdsPricingOnboard.ab_testing
                }
              }"
              class="nav-link"
              :class="{ 'popover--disabled': isActive.ab }"
              v-popover:tooltip.right="$t('analytic.ab.description')"
            >
              <i class="icon icon-new-analytics"></i>
              <span class="text-item">{{ $t("analytic.ab.title") }}</span>
              <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("dataNewPlan.plan.build") }}</span>
            </router-link>
          </template>
        </article>

        <article class="pages d-none d-lg-flex flex-column">
          <div class="nav-link subtitle">
            <span>{{ $t("upperCase.3rd") }}</span>
          </div>
          <router-link :to="{ name: 'Integrations' }" class="nav-link" :class="{ 'popover--disabled': isActive.integration }" v-popover:tooltip.right="$t('integration.tooltip')">
            <i class="icon icon-new-intergration"></i>
            <span class="text-item">{{ $t("integration.title") }}</span>
          </router-link>
          <!-- <router-link :to="{ name: 'ThankYouPage' }" class="nav-link" :class="{ 'popover--disabled': isActive.thankYouPage }" v-popover:tooltip.right="$t('thankYouPage.sidebarTooltip')">
            <i class="icon icon-reconvert"></i>
            <span class="text-item">{{ $t("thankYouPage.title") }}</span>
          </router-link> -->
          <div class="nav-link subtitle mt-2">
            <span>{{ $t("upperCase.support") }}</span>
          </div>
          <a href="https://help.gempages.net/" target="_blank" class="nav-link">
            <i class="icon icon-help"></i>
            <span class="text-item">{{ $t("generals.helpCenter.title") }}</span>
          </a>
          <!-- <div class="nav-link nav-link-feedback" @click="handleOpenFeedback">
            <i class="icon icon-feedback"></i>
            <span class="text-item">{{ $t("generals.giveFeedback") }}</span>
          </div> -->

          <div class="nav-link subtitle mt-2">
            <span>{{ $t("upperCase.setting") }}</span>
          </div>
          <router-link :to="{ name: 'AccountSettings' }" class="nav-link">
            <i class="icon icon-settings"></i>
            <span class="text-item">{{ $tc("generals.setting", 2) }}</span>
          </router-link>
        </article>
      </PerfectScrollbar>
      <Account :account.sync="shopInfo" />
      <!-- <div v-show="isDisplayFeedbackMsg" class="feedback-popover flex-column">
        <span class="typo-title2 typo-semibold mb-1">{{ $t("feedback.tooltip.title") }}</span>
        <span class="weight-400 typo-body4 mb-1">{{ $t("feedback.tooltip.description") }}</span>
        <span class="d-flex flex-grow-1 justify-content-end align-items-center typo-medium typo-body4">
          <span class="feedback-popover_action clickable" @click="gotFeedbackMsg">{{ $t("dashboard.customGotItButton") }}</span>
        </span>
      </div> -->
      <!-- <article class="acc-nav mt-auto">
          <div class="nav-link subtitle">
            <span>{{$t("upperCase.account")}}</span>
          </div>

          <router-link :to="{ name: 'AccountSettings' }" class="nav-link">
            <i class="icon icon-acc-settings"></i>

            <span class="text-item">{{$t("accountSettings.headerTitle")}}</span>
          </router-link>
      </article>-->
    </section>

    <div class="toggler" v-if="windowWidth < 1024" @click="toggleDrawer(null)">
      <i class="icon icon-arrow-right" v-if="isSidebarClosed"></i>
      <i class="icon icon-arrow-left" v-else></i>
    </div>
    <Portal to="tooltips">
      <tooltip :pointer="true" :width="'auto'" :delay="800" />
    </Portal>
  </aside>
  <aside class="sidebar" :class="{ collapsed: isSidebarClosed }" v-else-if="windowWidth >= 768 && mode == 'agency'">
    <a :href="url" class="logo justify-content-center justify-content-lg-start align-items-center">
      <i class="icon icon-arrow-left"></i>
      <span class="typo-paragraph12">{{ $t("sidebar.backShopify") }}</span>
    </a>

    <section class="sidenav">
      <PerfectScrollbar class="scrollBody">
        <router-link :to="{ name: 'AgencyDashboard' }" class="nav-link dashboard flex-shrink-0" :class="{ 'popover--disabled': isActive.agencyDashboard }" v-popover:tooltip.right="this.$t('agency.storeManager')">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.19999 9.76501C2.66115 9.76501 3.03499 10.1389 3.03499 10.6V17.8C3.03499 18.0016 3.19841 18.165 3.39999 18.165H16.6C16.8016 18.165 16.965 18.0016 16.965 17.8V10.6C16.965 10.1389 17.3388 9.76501 17.8 9.76501C18.2611 9.76501 18.635 10.1389 18.635 10.6V17.8C18.635 18.9239 17.7239 19.835 16.6 19.835H3.39999C2.27609 19.835 1.36499 18.9239 1.36499 17.8V10.6C1.36499 10.1389 1.73883 9.76501 2.19999 9.76501Z" fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.68178 0.165039H17.3184C17.991 0.164761 18.5734 0.631872 18.7191 1.28845L19.8151 6.21885C19.8284 6.27834 19.835 6.3391 19.835 6.40004C19.835 7.85531 18.6553 9.03504 17.2 9.03504C16.504 9.03504 15.8711 8.7652 15.4 8.32443C14.929 8.7652 14.296 9.03504 13.6 9.03504C12.904 9.03504 12.2711 8.7652 11.8 8.32443C11.329 8.7652 10.696 9.03504 10 9.03504C9.30404 9.03504 8.67107 8.7652 8.20004 8.32443C7.72901 8.7652 7.09603 9.03504 6.40004 9.03504C5.70404 9.03504 5.07107 8.7652 4.60004 8.32443C4.12901 8.7652 3.49603 9.03504 2.80004 9.03504C1.34477 9.03504 0.165039 7.85531 0.165039 6.40004C0.165039 6.33914 0.171701 6.27842 0.184907 6.21897L1.28039 1.2873C1.42718 0.631314 2.00959 0.164991 2.68178 0.165039ZM2.86942 1.83504L1.83812 6.47777C1.87771 6.97438 2.29325 7.36504 2.80004 7.36504C3.33299 7.36504 3.76504 6.93299 3.76504 6.40004H5.43504C5.43504 6.93299 5.86709 7.36504 6.40004 7.36504C6.93299 7.36504 7.36504 6.93299 7.36504 6.40004C7.36504 5.93888 7.73888 5.56504 8.20004 5.56504C8.6612 5.56504 9.03504 5.93888 9.03504 6.40004C9.03504 6.93299 9.46708 7.36504 10 7.36504C10.533 7.36504 10.965 6.93299 10.965 6.40004C10.965 5.93888 11.3389 5.56504 11.8 5.56504C12.2612 5.56504 12.635 5.93888 12.635 6.40004C12.635 6.93299 13.0671 7.36504 13.6 7.36504C14.133 7.36504 14.565 6.93299 14.565 6.40004C14.565 5.93888 14.9389 5.56504 15.4 5.56504C15.8612 5.56504 16.235 5.93888 16.235 6.40004C16.235 6.93299 16.6671 7.36504 17.2 7.36504C17.7068 7.36504 18.1223 6.97441 18.1619 6.47783L17.1299 1.83504H2.86942Z" fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.76495 13.6C6.76495 11.8134 8.21332 10.365 9.99995 10.365C11.7866 10.365 13.235 11.8134 13.235 13.6V19C13.235 19.4611 12.8611 19.835 12.4 19.835H7.59995C7.1388 19.835 6.76495 19.4611 6.76495 19V13.6ZM9.99995 12.035C9.13563 12.035 8.43495 12.7357 8.43495 13.6V18.165H11.565V13.6C11.565 12.7357 10.8643 12.035 9.99995 12.035Z" fill="currentColor" />
          </svg>
          <span class="text-item">{{ $t("agency.storeManager") }}</span>
        </router-link>
      </PerfectScrollbar>
      <!-- <Account :account.sync="shopInfo" /> -->
      <AgencyAccount v-if="agencyInfo" :account.sync="agencyInfo" :shops.sync="shops" />
    </section>

    <div class="toggler" v-if="windowWidth < 1024" @click="toggleDrawer(null)">
      <i class="icon icon-arrow-right" v-if="isSidebarClosed"></i>
      <i class="icon icon-arrow-left" v-else></i>
    </div>
    <Portal to="tooltips">
      <tooltip :pointer="true" :width="'auto'" :delay="800" />
    </Portal>
  </aside>

  <SidebarMobile v-else-if="windowWidth < 768 && mode == 'shop'" />
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
// import Logo from "./Logo";
import SidebarMobile from "./SidebarMobile";
import Account from "@/core/components/Account";
import AgencyAccount from "@/modules/Agency/components/Account.vue";
import { DASHBOARD_SIDEBAR_EVENT } from "@/config/constants/trackEventIds";
import dynamicTriggerContent from "@/mixins/dynamicTriggerContent";
// import openFeedbackForm from "@/utils/satismeter";
import { createThemeAndPageV7 } from "@/modules/Instant/utils";

export default {
  name: "Sidebar",
  components: {
    // Logo,
    Account,
    SidebarMobile,
    AgencyAccount
  },
  mixins: [dynamicTriggerContent()],
  props: {
    mode: {
      type: String,
      default: "shop"
    }
  },
  data() {
    return {
      url: "",
      height: 1024,
      windowWidth: 1024,
      prevRoute: null,
      showInstant: false
    };
  },
  computed: {
    ...mapState({
      recentPage: state => state.page.pages.recentPage.list,
      drawer: state => state.drawer.status,
      shopInfo: state => state.account.shopInfo,
      isSidebarClosed: state => state.drawer.opening,
      isDisplayFeedbackMsg: state => state.drawer.displayFeedbackMsg,
      permission: state => state.account.permissions,
      planLimitation: state => state.account.shopInfo?.planLimitation
    }),
    ...mapState("agency", {
      shops: state => state.shopList,
      agencyLogged: state => state.logged,
      agencyInfo: state => state.info
    }),
    isActive() {
      return {
        dashBoard: this.$route.name == "Dashboard" ? true : false,
        subPages: this.$route.name == "LandingPages" ? true : false,
        homePages: this.$route.name == "HomePages" ? true : false,
        productPages: this.$route.name == "ProductPages" ? true : false,
        collectionPages: this.$route.name == "CollectionPages" ? true : false,
        articlePages: this.$route.name == "ArticlePages" ? true : false,
        integration: this.$route.name == "Integrations" ? true : false,
        agencyDashboard: this.$route.name == "AgencyDashboard" ? true : false,
        AgencySettings: this.$route.name == "AgencySettings" ? true : false,
        thankYouPage: this.$route.name == "ThankYouPage" ? true : false,
        abTesting: this.$route.name == "ABTesting" ? true : false,
        instant: this.$route.name == "InstantPages" ? true : false
      };
    },
    scrollOptions() {
      return {
        wheelSpeed: 0.25,
        swipeEasing: true,
        wheelPropagation: false,
        suppressScrollX: true
      };
    },
    isGemPagesV7() {
      return (this && this.shopInfo && this.shopInfo.isGemPagesV7) || window.___gemShopInfo.isGemPagesV7 || false;
    }
  },
  watch: {
    // recentPage() {
    //   this.setDisplayFeedbackMsg();
    // },
    $route: {
      deep: true,
      handler(_, from) {
        this.prevRoute = window.location.origin + from.fullPath;

        this.windowResizeHandler();
        // this.checkOpenSubmenu();
      }
    }
  },
  created() {
    this.DASHBOARD_SIDEBAR_EVENT = DASHBOARD_SIDEBAR_EVENT;

    this.$nextTick(() => {
      this.windowResizeHandler();
      this.resizeHandler();
      let handler = this.windowResizeHandler;
      window.addEventListener("resize", handler);
      // this.checkOpenSubmenu();
    });
    if (!(this.$route.name || "").includes("Agency")) {
      this.url = new URL("/admin", "https://" + this.shopInfo.shopifyDomain);
    }

    if (["professional", "advanced", "starter", "plus", "build", "enterprise", "optimize"].includes(this.shopInfo?.plan)) {
      this.showInstant = true;
    }
  },
  async mounted() {
    // this.setDisplayFeedbackMsg();
    this.windowResizeHandler();
    // this.checkOpenSubmenu();
  },
  beforeDestroy() {
    let handler = this.windowResizeHandler;
    this.$nextTick(() => {
      window.removeEventListener("resize", handler);
    });
  },
  methods: {
    ...mapMutations({
      toggleDrawer: "drawer/DRAWER_TOGGLE_DRAWER",
      updateSize: "drawer/DRAWER_UPDATE_WINDOW_SIZE",
      setDisplayFeedback: "drawer/SET_DISPLAY_FEEDBACK"
    }),
    ...mapActions("common", {
      trackEvent: "trackEvent"
    }),
    ...mapActions("page", {
      createPageWithOneTap: "createPageWithOneTap"
    }),
    goTo(routeName) {
      if (!this.shopInfo.isGemPagesV7) {
        return { name: routeName };
      }

      const paramGemPageV7 = {
        LandingPages: "/instant/landing-pages",
        HomePages: "/instant/home-pages",
        ProductPages: "/instant/product-pages",
        CollectionPages: "/instant/collection-pages",
        ArticlePages: "/instant/article-pages"
      };

      return {
        path: paramGemPageV7[routeName]
      };
    },
    currentLocation() {
      const prevRoute = this.prevRoute;
      this.prevRoute = null;

      return prevRoute || window.location.href;
    },

    trackSidebarEvent(eventId) {
      this.trackEvent({ event_id: eventId, path: this.currentLocation() });
    },

    async onCreateNewPage(pageType, eventId) {
      await this.trackEvent({ event_id: eventId, path: this.currentLocation() });

      if (this.shopInfo.isGemPagesV7) {
        await createThemeAndPageV7(pageType);
        return;
      }

      await this.createPageWithOneTap({ type: pageType });
      return false;
    },

    resizeHandler() {},

    windowResizeHandler() {
      // this.setDisplayFeedbackMsg();

      // console.warn("TGGLE");
      this.height = window.innerHeight;
      this.windowWidth = window.innerWidth;
      this.updateSize({
        width: this.windowWidth,
        height: this.height
      });

      // if (!this.$route.meta.allowAutoSidebar) {
      //   // console.warn("This route is not allowed to auto close/open sidebar");
      //   this.toggleDrawer(false);
      //   return;
      // }
      if (this.windowWidth < 1024) {
        // If it's Opening => Close it
        if (!this.isSidebarClosed) {
          // console.warn(
          //   `SIDEBAR CONTROL =>>>>>>> CLOSE SIDEBAR with windowWidth = ${this.windowWidth}`
          // );
          this.toggleDrawer();
        }
      } else {
        // If it's closed => Open it
        if (this.isSidebarClosed) {
          // console.warn(
          //   `SIDEBAR CONTROL =>>>>>>> OPEN SIDEBAR with windowWidth = ${this.windowWidth}`
          // );
          this.toggleDrawer();
        }
      }
    },
    goDashboard() {
      event.preventDefault();
      var protocol = location.protocol;
      var slashes = protocol.concat("//");
      var host = slashes.concat(window.location.hostname);
      alert(host);
      window.location.href = host + "/admin/dashboard";
    },
    goDashboardRoot() {
      let url = window.location.href;
      let arr = url.split("/");
      let host = arr[0] + "//" + arr[2];
      window.location.href = host + "/admin/dashboard";
    },
    // handleOpenFeedback() {
    //   this.gotFeedbackMsg();
    //   openFeedbackForm();
    // },
    isDisplayInSidebar(el) {
      const SIDEBAR_FOOTER_HEIGHT = 70;
      const rect = el.getBoundingClientRect();
      return rect.bottom <= (window.innerHeight - SIDEBAR_FOOTER_HEIGHT || document.documentElement.clientHeight - SIDEBAR_FOOTER_HEIGHT);
    },
    // gotFeedbackMsg() {
    //   const key = "gotFeedbackMsg";
    //   const shopId = this.shopInfo.shopId;
    //   const listItem = localStorage.getItem(key);
    //   const list = listItem ? JSON.parse(listItem) : [];
    //   if (!list.includes(shopId)) {
    //     list.push(shopId);
    //   }
    //   localStorage.setItem(key, JSON.stringify(list));
    //   this.setDisplayFeedback(false);
    // },
    // setDisplayFeedbackMsg() {
    //   const $feedbackItem = document.querySelector(".nav-link-feedback");
    //   const $message = document.querySelector(".feedback-popover");

    //   if (!$message || !$feedbackItem) return;
    //   if (!this.isDisplayInSidebar($feedbackItem)) {
    //     this.setDisplayFeedback(false);
    //     return;
    //   }

    //   const hasNotGotMsg = !localStorage.getItem("gotFeedbackMsg")?.includes(this.shopInfo.shopId);
    //   const hasRecentPage = this.recentPage.length > 0;
    //   this.setDisplayFeedback(hasNotGotMsg && hasRecentPage);

    //   const MESSAGE_POSITION = $feedbackItem.getBoundingClientRect().top - 165;
    //   $message.style.top = `${MESSAGE_POSITION}px`;
    // },
    // observeScroll() {
    //   this.setDisplayFeedbackMsg();
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "@/core/themes/partials/_utils.scss";
@import "@/core/themes/partials/_tooltips.scss";

// @import "@/core/themes/base.scss";

.sidebar {
  position: fixed;
  margin-top: 60px;
  left: 0;
  top: 0;
  height: 100vh;
  width: 280px;
  background-color: $dark7;
  border-top: solid 1px $dark8;
  display: flex;
  flex-direction: column;
  @include trans-all;
  z-index: 49;
  .noHover {
    pointer-events: none;
  }
  > a,
  > a:visited {
    color: $textDarkModeLowContrast;
    background-color: $dark7;
  }
  > a:hover {
    color: $textDarkModeHigh;
    background-color: $dark5;
  }
  > a:first-child:hover {
    background-color: $dark2;
  }
  .logo {
    // width: calc(100%);
    padding: 9.5px 0px 9.5px 24px;
    height: 40px;
    display: flex;
    border-bottom: 1px solid $dark4;
    .icon {
      margin-right: 16px;
      font-size: 16px;
    }
    &__text {
      color: $textDarkModeLowContrast;
      line-height: 22px !important;
    }
  }
  .logo-agency {
    padding: 16px;
  }

  section.account-container {
    max-height: 120px;
    background: $dark4;
    position: relative;
    margin-top: auto;
    margin-bottom: 60px;
    border-top: solid 1px $dark8;
    .account {
      // height: 100%;
      width: 100%;
    }
  }

  .sidenav {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    // width: calc(100% + 2px);

    .pages {
      margin-bottom: 24px;
    }

    .help-center {
      margin-top: auto;

      .gp_dropdown {
        &_list {
          top: unset;
          bottom: 100%;
          right: -16px;
        }
      }
    }

    .acc-nav {
      margin-bottom: 19px;
    }

    .nav-link {
      padding: 10px 0 10px 21px;
      border-left: 3px solid $dark3;
      display: flex;
      position: relative;
      flex-direction: row;
      align-items: center;
      font-weight: 500;
      text-decoration: none;
      @include trans-all;
      @include no-select;
      &__quick-add {
        padding: 0;
        $size: 32px;
        width: $size;
        height: $size;
        background: inherit;
        margin-left: auto;
        display: none;
        z-index: 10;
        position: absolute;
        top: calc(50% - calc($size / 2));
        right: 8px;
        .icon {
          top: unset !important;
          font-size: 16px !important;
          line-height: 16px !important;
          color: $light1 !important;
        }
        &:hover {
          background: $dark5;
        }
      }

      &.rl-active {
        .nav-link__quick-add {
          &:hover {
            background: $dark8;
          }
        }
      }

      .text-item {
        height: 17px;
        font-size: 14px;
        line-height: 17px;
      }

      &:not(.disabled) {
        color: $textDarkModeLowContrast;
      }

      &.disabled {
        color: $textDarkModeDisabled !important;
        i.icon {
          color: $textDarkModeDisabled !important;
        }
        &.open .arrow i.icon {
          color: $textDarkModeDisabled !important;
        }
      }

      &.view-more {
        padding-left: 0;
      }

      &,
      &:active {
        color: inherit;
      }

      &.subtitle {
        color: $textDarkModeDisabled;
        font-size: 12px;
        line-height: 18px;
        padding-top: 0;
        padding-bottom: 0;
        margin-bottom: 8px;
        letter-spacing: 0.5px;
      }

      svg,
      i.icon {
        margin-right: 16px;
        font-size: 20px;
        line-height: 20px;
        color: $textDarkModeHigh;
        transition: all 0.3s ease;
        position: relative;
        top: -1px;
      }

      &.dashboard {
        margin-bottom: 24px;
      }

      // &:not(:first-child) {
      //   padding-top: calc(16px + 5px);
      // }

      &:not(.subtitle):not(.disabled):not(.rl-active):hover {
        border-left: 3px solid $dark2;
        svg,
        i.icon {
          color: $textDarkModeHigh;
        }
        .text-item {
          color: $textDarkModeHigh;
        }
        background-color: $dark8;
        cursor: pointer;
        // .tooltip {
        //   visibility: visible;
        //   opacity: 1;
        //   z-index: 101;
        // }
      }

      &__quick-add {
        i.typo-icon-12 {
          font-size: 18px;
          line-height: 18px;
          color: $light5;
        }
      }
      &:hover .nav-link__quick-add {
        display: flex;
      }
      &.rl-eactive,
      &.rl-active {
        svg,
        i.icon {
          color: $textDarkModeHigh;
        }
        .text-item {
          color: $textDarkModeHigh;
        }
        border-left: 3px solid $textDarkModeHigh;
        padding-left: 21px;
        background-color: $dark5;
        cursor: pointer;
      }

      // &.rl-eactive {
      //   color: $cPrimary;
      //   // border-right: 2px solid $cPrimary;
      //   // width: calc(100% - 24px);
      // }

      &.open {
        .arrow {
          display: flex;
          align-items: center;
          margin-left: auto;

          i.icon {
            font-size: 12px;
            line-height: 12px;
            color: $black1;
            font-weight: 500;
          }
        }
      }

      // i.icon.icon-menu {
      //   transform: rotate(90deg);
      // }

      .badge {
        margin-left: 8px;
      }
    }

    .sub-nav {
      background-color: $grey5;
      padding: 5px 0 5px 20px;
      margin-top: 8px;
    }
  }

  &.collapsed {
    width: 80px;
    min-width: 80px;

    .logo {
      i {
        display: none;
      }
      padding-left: 20px;
    }

    .sidenav {
      // padding-top: 20px;

      .nav-link {
        padding-left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        &:not(.subtitle) > span {
          display: none;
        }

        &.subtitle {
          text-align: center;
          padding-left: 0;
          margin-top: 24px;
          padding: 0 8px;

          span {
            width: 100%;
          }
        }

        &:not(:first-child) {
          padding-top: calc(8px + 5px);
        }

        i.icon {
          margin-right: 0px;
          font-size: 26px;
        }

        &.dashboard {
          margin: 0;
        }
      }

      .pages {
        margin-bottom: 0;
      }

      .sub-nav {
        padding-left: 0px;
      }

      .help-center {
        .view-more {
          margin-top: 0;
        }

        .gp_dropdown {
          ::v-deep {
            .no-padding {
              padding: 0 0 0 24px;
            }

            .gp_dropdown_list {
              width: 200px;
              left: 10px;

              span {
                display: inline;
              }
            }
          }
        }
      }

      .acc-nav {
        margin: 0 0 16px 0;
      }
    }

    & + .gp-wrapper {
      margin-left: 80px;
    }

    ::v-deep .account-container {
      min-height: 36px;
      margin-bottom: 16px;

      .account {
        padding: 9px;
      }

      .name,
      .plan > span {
        display: none;
      }

      .upgrade > i.icon {
        margin: 0 4px !important;
      }
    }

    .toggler {
      width: 25px;
      padding-left: 8px;
    }
  }

  .toggler {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 12px;
    right: -25px;
    padding: 4px;
    height: 24px;
    width: 50px;
    padding-left: 28px;
    border-radius: 0px 5px 5px 0px;
    font-size: 14px;
    background: $dark3;
    color: $textDarkModeHigh;
    cursor: pointer;
    z-index: -1;
  }
}

.badge {
  display: flex;
  padding: 1px 5px;
  font-size: 10px;
  line-height: 10px;
  border-radius: 3px;
  min-width: 16px !important;
  min-height: 16px !important;
  justify-content: center;
  align-items: center;

  &-danger {
    background-color: $cRed;
    color: #fff;
  }
  &-warn {
    // background-color: ;
    border: 1px solid $accent-yellow;
    color: $accent-yellow;
  }

  &-instant {
    color: #fff;
    background-color: $cPrimary;
  }

  &-new {
    border: 1px solid $accent-green;
    color: $accent-green;
  }

  &-pro {
    background: $mono3;
    color: $light1;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
  }
}

.feedback-popover {
  display: flex;
  padding: 12px;
  position: absolute;
  width: 244px;
  height: 129px;
  left: 102%;
  color: $neutral5;
  background: $dark6;
  border-radius: 4px;
  &_action {
    @include trans-all;
    width: fit-content;
    padding: 7px 8px;
    border-radius: 3px;
    color: $textDarkModeHigh;
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
  &::after {
    content: "";
    position: absolute;
    right: 100%;
    top: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent $dark6 transparent transparent;
  }
}

.disabled .badge-warn .badge-new {
  opacity: 0.6;
}

.scrollBody {
  max-height: calc(100vh - 60px - 40px - 16px - 74px);
}

// trial se co them nut de upgrade nen can tinh lai max-height cho scrollBody theo cac breakpoint
.trial-plan {
  .scrollBody {
    max-height: calc(100vh - 60px - 40px - 16px - 120px);
  }
}

// starter cung co them nut de upgrade nen can tinh lai max-height cho scrollBody theo cac breakpoint
.starter-plan {
  .scrollBody {
    max-height: calc(100vh - 60px - 40px - 16px - 120px);
  }
}

@media screen and (min-width: 1440px) {
  .sidebar {
    min-width: 280px;
  }
}

@media screen and (max-width: 1439px) {
  .sidebar {
    min-width: 280px;
    width: 280px;
  }
}

@media screen and (max-width: 1279px) {
  .sidebar {
    width: 224px;
    min-width: 224px;
  }
}

@media screen and (max-width: 1023px) {
  .sidebar {
    ::v-deep .account-container {
      margin-bottom: 16px;
    }

    .sidenav .nav-link.subtitle {
      margin-top: 24px;
    }

    &:not(.collapsed) {
      .logo {
        justify-content: flex-start !important;
      }
    }
  }
}

@media screen and (max-height: 672px) {
  .sidebar {
    .sidenav {
      margin-top: 12px;
      .pages {
        margin-bottom: 16px;
      }
      .nav-link {
        &.subtitle {
          margin-bottom: 8px;
        }
        &.dashboard {
          margin-bottom: 16px;
        }
      }
    }

    .account-container {
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }

    ::v-deep.account {
      .plan {
        margin-bottom: 12px;
      }
    }
  }

  .scrollBody {
    max-height: calc(100vh - 60px - 40px - 12px - 64px);
  }

  .trial-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 40px - 12px - 92px);
    }
  }

  .starter-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 40px - 12px - 102px);
    }
  }
}

@media screen and (max-height: 600px) {
  .sidebar {
    .sidenav {
      margin-top: 8px;
      .pages {
        margin-bottom: 8px;
      }
      .nav-link {
        padding-top: 8px;
        padding-bottom: 8px;
        &.subtitle {
          margin-bottom: 4px;
        }
        &.dashboard {
          margin-bottom: 8px;
        }
      }
    }

    ::v-deep.account {
      .plan {
        margin-bottom: 8px;
      }
    }
  }

  .scrollBody {
    max-height: calc(100vh - 60px - 35px - 8px - 70px);
  }

  .trial-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 35px - 8px - 80px);
    }
  }

  .starter-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 35px - 8px - 90px);
    }
  }
}
</style>
